// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "iblCombineVoxelGridsPixelShader";
const shader = `varying vUV: vec2f;
var voxelXaxisSamplerSampler: sampler;
var voxelXaxisSampler: texture_3d<f32>;
var voxelYaxisSamplerSampler: sampler;
var voxelYaxisSampler: texture_3d<f32>;
var voxelZaxisSamplerSampler: sampler;
var voxelZaxisSampler: texture_3d<f32>;
uniform layer: f32;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {var coordZ: vec3f= vec3f(fragmentInputs.vUV.x,fragmentInputs.vUV.y,uniforms.layer);
var voxelZ: f32=textureSample(voxelZaxisSampler,voxelZaxisSamplerSampler,coordZ).r;
var coordX: vec3f= vec3f(1.0-uniforms.layer,fragmentInputs.vUV.y,fragmentInputs.vUV.x);
var voxelX: f32=textureSample(voxelXaxisSampler,voxelXaxisSamplerSampler,coordX).r;
var coordY: vec3f= vec3f(uniforms.layer,fragmentInputs.vUV.x,fragmentInputs.vUV.y);
var voxelY: f32=textureSample(voxelYaxisSampler,voxelYaxisSamplerSampler,coordY).r;
var voxel=select(0.0,1.0,(voxelX>0.0 || voxelY>0.0 || voxelZ>0.0));fragmentOutputs.color= vec4f( vec3f(voxel),1.0);}`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}

/** @internal */
export const iblCombineVoxelGridsPixelShaderWGSL = { name, shader };
